import React, { useEffect, useState } from "react";
import { useToast } from "@chakra-ui/react";
import { ModalBox } from "../ModalBox";
import { VimeoUploadForm } from "../VimeoUploadForm";

export const UploadVideoModal = ({ isOpen, onCloseModal, handleUpload }) => {
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        tags: [],
        categories: "",
        language: "",
        videoFile: null,
    });
    const [tagInput, setTagInput] = useState("");
    const toast = useToast();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({ ...prev, videoFile: new File([e.target.files[0]], e.target.files[0].name.replace(/ /g, ''), {
            type: e.target.files[0].type,
            lastModified: e.target.files[0].lastModified,
        })}));
    };

    const updateTagInput = (e) => {
        setTagInput(e.target.value);
    }

    const addTag = () => {
        if (tagInput.trim() && !formData.tags.includes(tagInput.trim())) {
            setFormData((prev) => ({ ...prev, tags: [...prev.tags, tagInput.trim()] }));
            setTagInput("");
        }
    };

    const removeTag = (tagToRemove) => {
        setFormData((prev) => ({
            ...prev,
            tags: prev.tags.filter((tag) => tag !== tagToRemove),
        }));
    };
    const onSubmit = (e) => {
        e.preventDefault();

        if (!formData.title || !formData.videoFile) {
            toast({
                position: "top-right",
                title: "Title and Video File are required.",
                status: "error",
                duration: 3000,
                isClosable: true
            });
            return;
        }

        handleUpload(formData);
    };

    const clearFields = () => {
        setFormData({
            title: "",
            description: "",
            tags: [],
            categories: "",
            language: "",
            videoFile: null,
        });
        setTagInput("");
    }

    useEffect(() => {
     return () => clearFields();
    }, [])
    return (
        <ModalBox
            title="Upload Video"
            size="xl"
            description={
                <VimeoUploadForm
                    formData={formData}
                    tagInput={tagInput}
                    updateTagInput={updateTagInput}
                    handleChange={handleChange}
                    handleFileChange={handleFileChange}
                    addTag={addTag}
                    removeTag={removeTag}
                />
            }
            isOpen={isOpen}
            onClose={onCloseModal}
            isFooter={true}
            cancelButtonText="Cancel"
            confirmButtonText="Upload Video"
            onCancel={onCloseModal}
            loadingText="Uploading"
            onConfirm={onSubmit}
        />
    );
};